export const AD_CONSENT_KEY = "adConsentChoice";

export function hasAdConsent(settings = {}) {
  if (settings?.adSettings?.consentRequired === false) return true;
  return Boolean(localStorage.getItem(AD_CONSENT_KEY));
}

export function saveAdConsent(choice) {
  localStorage.setItem(AD_CONSENT_KEY, JSON.stringify({ choice, acceptedAt: new Date().toISOString() }));
}
